import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import TextField from '../../artzu-ui/src/TextField';
import Button from '../../artzu-ui/src/Button';
import ProgressBar from '../../artzu-ui/src/ProgressBar';

class ReferAFriend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codeCopied: false,
      urlCopied: false,
      display: "share"
    };
  }

  copyCode = () =>
    this.setState({ codeCopied: true }, () => setTimeout(() => this.setState({ codeCopied: false }), 2000));
  copyUrl = () => this.setState({ urlCopied: true }, () => setTimeout(() => this.setState({ urlCopied: false }), 2000));

  render() {
    const { referralCode, referralUrl, promotionMessage, rules, media, referrals } = this.props;
    const { display } = this.state;
    return (
      <div className="refer-a-friend">
        {media === 'desktop' ? <p style={{ fontSize: '23px', fontWeight: '600' }}>Refer a Friend</p> : null}
        <div className="referral-select">
          <Button
            className="referral-button"
            label="Share"
            color="#414141"
            primary={display === "share"}
            onClick={() => this.setState({ display: "share" })}
            padding="0"
            margin="0 0.5em 0 0"
          />
          <Button
            className="referral-button"
            label="Invites"
            color="#414141"
            primary={display === "invites"}
            onClick={() => this.setState({ display: "invites" })}
            padding="0"
            margin="0"
          />
        </div>
        {display === "share" ? 
        <div className="share-display">
          <div className="referral-info">
            <CopyToClipboard onCopy={this.copyCode} text={referralCode} className="referral-code">
              <TextField
                width="100%"
                heading="Referral Code"
                value={referralCode}
                noBorder
                onChange={() => {}}
                textColor="#414141"
              />
            </CopyToClipboard>
            <CopyToClipboard onCopy={this.copyCode} text={referralCode}>
              <button id="copy-btn" className="referral-copy">
                {this.state.codeCopied ? 'Copied!' : 'Copy'}
              </button>
            </CopyToClipboard>
          </div>
          <div className="referral-info">
            <CopyToClipboard onCopy={this.copyUrl} text={referralUrl} className="referral-url">
              <TextField
                width="100%"
                heading="Referral Link"
                value={referralUrl}
                noBorder
                onChange={() => {}}
                textColor="#414141"
              />
            </CopyToClipboard>
            <CopyToClipboard onCopy={this.copyUrl} text={referralUrl}>
              <button id="copy-btn" className="referral-copy">
                {this.state.urlCopied ? 'Copied!' : 'Copy'}
              </button>
            </CopyToClipboard>
          </div>
          <p className="promo-desc">{promotionMessage}</p>
          {rules}
        </div> : null}
        {display === "invites" ? 
        <div className="invites-display">
          {referrals ? 
            referrals.map((referral, index) => {
              return (
                <div className={`referred-user ${index > 0 ? "top-border" : ""}`} key={index}>
                  <p style={{fontWeight: 600, marginTop: "1em"}}>{referral.referredUserName}</p>
                  <div className="progress-display">
                    {["operating", "redeemed"].includes(referral.referralStatus) ? 
                    <ProgressBar
                      fillers={[
                        referral.hoursDriven === 0 ? 0 : Math.max(Math.min(referral.hoursDriven * 100 / 20, 100), 12)
                      ]}
                      className="promo-pbar"
                      borderColor="#414141"
                      primaryColor={referral.hoursDriven >= 20 ? "#128dff" : "#414141"}
                    /> :
                    <p className="new-referral">{referral.referralStatus[0].toUpperCase() + referral.referralStatus.slice(1)}</p>}
                    <p style={{color: referral.referralStatus === "redeemed" ? "#128dff" : "#414141"}}>
                      {referral.referralStatus === "redeemed" ? 
                        "+$50" : `${Math.min(referral.hoursDriven, 20)}/20`}
                    </p>
                  </div>
                </div>
              )
            }) : 
            <div></div>}
        </div> : null}
      </div>
    );
  }
}

export default ReferAFriend;



// WEBPACK FOOTER //
// ./src/components/Promotion/ReferAFriend.js